import { BoardServiceLinesStateInterface } from '.';

function state(): BoardServiceLinesStateInterface {
  return {
    boardServiceLines: [],
  };
}

export default state;
